import { Item, LengthAwarePage } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import type { operations } from '@/api/generated/openapi';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';
import { toItem, WithInventoryItems } from './index';

export type ReconcileResponse = WithInventoryItems<operations['reconcile-inventory']['responses']['200']['content']['application/json']>;

// The server's paginator nulls these on an empty page.
export type ReconcilePage = Omit<LengthAwarePage<Item>, 'from' | 'to' | 'nextPageUrl' | 'prevPageUrl'> & {
    from: number | null
    to: number | null
    nextPageUrl: string | null
    prevPageUrl: string | null
};

function toReconcilePage(page: ReconcileResponse): ReconcilePage {
    return {
        data: page.data.map(item => toItem(item)),
        total: page.total,
        perPage: page.per_page,
        currentPage: page.current_page,
        lastPage: page.last_page,
        firstPageUrl: page.first_page_url,
        lastPageUrl: page.last_page_url,
        nextPageUrl: page.next_page_url,
        prevPageUrl: page.prev_page_url,
        path: page.path,
        from: page.from,
        to: page.to,
    };
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { fetchReconcileItems: (skus?: Array<string>, pageNumber?: number) => Promise<ReconcilePage>; } => ({
    fetchReconcileItems: async (skus: Array<string> = [], pageNumber: number = 1): Promise<ReconcilePage> => {
        const response = await axios.get<ReconcileResponse>(skus.reduce((url, sku) => `${url}skus[]=${sku}&`, `/api/inventory/reconcile?page=${pageNumber}&`));

        return toReconcilePage(response.data);
    },
});
